module.exports = __webpack_public_path__ + "media/referral/mobile_banner-e9825b1c.png";